module.exports = __webpack_public_path__ + "img/H16-2.png";